import { MessageCircle, Phone } from "lucide-react";
import Reveal from "@/components/Reveal";
import { LINKS, PHONE_DISPLAY, PHONE_TEL } from "@/data/content";

export default function FinalCTA() {
  return (
    <section
      id="contato"
      data-testid="final-cta-section"
      className="relative overflow-hidden py-28 sm:py-36"
      style={{ background: "linear-gradient(135deg, #FF5A36 0%, #FF2A6D 50%, #0055FE 110%)" }}
    >
      <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-white/10 blur-3xl" />
      <div className="absolute -bottom-40 -right-24 w-[28rem] h-[28rem] rounded-full bg-[#0B1120]/20 blur-3xl" />

      <div className="relative max-w-4xl mx-auto px-5 sm:px-8 text-center text-white">
        <Reveal>
          <p className="font-mono text-[11px] sm:text-xs tracking-[0.35em] text-white/85 mb-6">
            QUAL É A SUA PRÓXIMA VIAGEM?
          </p>
          <h2 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl">
            Vamos planejar <em className="font-serif italic font-medium">juntos.</em>
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-6 text-base sm:text-lg text-white/90 leading-relaxed max-w-2xl mx-auto">
            Você já sabe para onde quer ir? Ou ainda está procurando o destino ideal? Me conte o que você está
            planejando. Vamos encontrar uma viagem que combine com você.
          </p>
        </Reveal>
        <Reveal delay={0.22} className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a
            href={LINKS.cotacao}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-whatsapp-btn"
            className="inline-flex items-center gap-2 rounded-full bg-white text-[#0B1120] font-semibold px-8 py-4 hover:bg-[#0B1120] hover:text-white transition-colors duration-300"
          >
            <MessageCircle size={20} />
            Fale com João Garcez
          </a>
          <a
            href={PHONE_TEL}
            data-testid="final-cta-phone-btn"
            className="inline-flex items-center gap-2 rounded-full border-2 border-white/60 text-white font-semibold px-8 py-4 hover:bg-white/10 transition-colors duration-300"
          >
            <Phone size={18} />
            {PHONE_DISPLAY}
          </a>
        </Reveal>
      </div>
    </section>
  );
}
